import { makeStyles } from '../../utils/makeStyles';

const useStyles = makeStyles(() => ({
  root: {},
}));

export default useStyles;
